// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledCurrency from '../../../shared/components/labeled-currency';
import {Link} from 'react-router';
import {buildClaimsQueryFromParams} from '../../shared/services/build-query';
import {buildNumber} from '../../../shared/services/build-number';

const getHeader = display =>
    display.map((element, index) =>
        <span
            className='bread-crumb'
            key={index}
        >
            {element}
        </span>
    );

const DetailPanel = props =>
    <section className='detail-panel'>
        <header>
            <nav className='bread-crumbs'>
                {getHeader(props.detail.display)}
                <Link to={`/reimbursement-summary/claims?${buildClaimsQueryFromParams(props.queryParams)}`}>
                    <FormattedMessage
                        id='CLAIMS_WITH_COUNT'
                        values={{
                            count: buildNumber(props.detail.data.approvedClaimCount)
                        }}
                    />
                </Link>
            </nav>
        </header>
        <section className='summary'>
            <LabeledCurrency
                data={props.detail.data.recoveryPercentage}
                label='RECOVERY'
            />
            <LabeledCurrency
                data={props.detail.data.totalUnpaid}
                label='TOTAL_UNPAID'
            />
        </section>
    </section>;

DetailPanel.displayName = 'DetailPanel';
DetailPanel.propTypes = {
    detail: PropTypes.object.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default DetailPanel;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/components/detail-panel.js